module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074b5_banner_800x600.f9c33ae7.png";